export default __webpack_public_path__ + "static/media/photoshop.3a1370bb.gif";